;(function () {
  angular
    .module('contrast.notifications.settings.org')
    .controller('NotificationOrgSettingsCtrl', NotificationOrgSettingsCtrl)

  function NotificationOrgSettingsCtrl(
    $log,
    $scope,
    $routeParams,
    $q,
    $translate,
    WebhookFactory,
    NotificationOrganizationSettingsService,
    ErrorService,
    ATTACK_STATUS,
    RULE_SEVERITY_LIST,
    NOTIFICATION_ASSET_TYPE,
    SERVER_ENVIRONMENT,
    INTEGRATION_TYPE,
    permissions
  ) {
    'ngInject'

    var tooltipValid =
      'views/tooltips/organization/settings/notificationChannelTooltipValid.html'
    var tooltipInvalid =
      'views/tooltips/organization/settings/notificationChannelTooltipInvalid.html'

    const microsoftTeamsLogo = 'images/integrations/microsoft-teams-logo.png'

    var webhookImgLookup = {
      [INTEGRATION_TYPE.SLACK]: 'images/integrations/slackIcon.png',
      [INTEGRATION_TYPE.GENERIC]: 'images/integrations/webhookIcon.png',
      [INTEGRATION_TYPE.VICTOROPS]: 'images/integrations/victorOpsIcon.png',
      [INTEGRATION_TYPE.PAGERDUTY]: 'images/integrations/pagerduty.png',
      [INTEGRATION_TYPE.MICROSOFTTEAMS]: microsoftTeamsLogo,
      [INTEGRATION_TYPE.NEW_MICROSOFTTEAMS]: microsoftTeamsLogo
    }

    function init() {
      $q.all([
        NotificationOrganizationSettingsService.init(
          $scope.select.vulns_options
        ),
        loadWebhooks()
      ])
        .then(function () {
          $scope.settings = NotificationOrganizationSettingsService.settings

          var selected = determineSelectedWebhook($routeParams.integrationId)

          if (selected) {
            NotificationOrganizationSettingsService.setSelectedWebhook(selected)
            webhookChanged($scope.settings.selected_webhook)
            ;[
              $scope.settings.new_vulnerability,
              $scope.settings.new_attack,
              $scope.settings.new_asset
            ].forEach(NotificationOrganizationSettingsService.reloadShowOptions)
          }
        })
        .catch($log.error)
    }

    //models
    $scope.settings = NotificationOrganizationSettingsService.settings

    var translGlobal = {
      title_attackStatusProbed: $translate.instant('title_attackStatusProbed'),
      title_attackStatusBlocked: $translate.instant(
        'title_attackStatusBlocked'
      ),
      title_attackStatusExploited: $translate.instant(
        'title_attackStatusExploited'
      ),
      title_attackStatusBlockedPerimeter: $translate.instant(
        'title_attackStatusBlockedPerimeter'
      ),
      title_attackStatusSuspicious: $translate.instant(
        'title_attackStatusSuspicious'
      ),
      title_attackStatusProbedPerimeter: $translate.instant(
        'title_attackStatusProbedPerimeter'
      )
    }

    angular.extend($scope, {
      select: {
        attack_status: [
          {
            value: ATTACK_STATUS.EXPLOITED.value,
            name: translGlobal.title_attackStatusExploited
          },
          {
            value: ATTACK_STATUS.SUSPICIOUS.value,
            name: translGlobal.title_attackStatusSuspicious
          },
          {
            value: ATTACK_STATUS.BLOCKED_PERIMETER.value,
            name: translGlobal.title_attackStatusBlockedPerimeter
          },
          {
            value: ATTACK_STATUS.BLOCKED.value,
            name: translGlobal.title_attackStatusBlocked
          },
          {
            value: ATTACK_STATUS.PROBED_PERIMETER.value,
            name: translGlobal.title_attackStatusProbedPerimeter
          },
          {
            value: ATTACK_STATUS.PROBED.value,
            name: translGlobal.title_attackStatusProbed
          }
        ],
        vulns_options: [
          {
            value: RULE_SEVERITY_LIST[0].value,
            name: RULE_SEVERITY_LIST[0].name,
            group: 'SEVERITY'
          },
          {
            value: RULE_SEVERITY_LIST[1].value,
            name: RULE_SEVERITY_LIST[1].name,
            group: 'SEVERITY'
          },
          {
            value: RULE_SEVERITY_LIST[2].value,
            name: RULE_SEVERITY_LIST[2].name,
            group: 'SEVERITY'
          },
          {
            value: RULE_SEVERITY_LIST[3].value,
            name: RULE_SEVERITY_LIST[3].name,
            group: 'SEVERITY'
          },
          {
            value: RULE_SEVERITY_LIST[4].value,
            name: RULE_SEVERITY_LIST[4].name,
            group: 'SEVERITY'
          },
          {
            value: SERVER_ENVIRONMENT.DEVELOPMENT.value,
            name: SERVER_ENVIRONMENT.DEVELOPMENT.name,
            group: 'ENVIRONMENT'
          },
          {
            value: SERVER_ENVIRONMENT.QA.value,
            name: SERVER_ENVIRONMENT.QA.name,
            group: 'ENVIRONMENT'
          },
          {
            value: SERVER_ENVIRONMENT.PRODUCTION.value,
            name: SERVER_ENVIRONMENT.PRODUCTION.name,
            group: 'ENVIRONMENT'
          }
        ],
        assets: [
          { value: NOTIFICATION_ASSET_TYPE.APPLICATION },
          { value: NOTIFICATION_ASSET_TYPE.SERVER }
        ],
        webhooks: []
      }
    })

    //functions
    angular.extend($scope, {
      isEOP: permissions.isEOP,
      webhookChanged: webhookChanged,
      getNotificationChannelTooltip: getNotificationChannelTooltip,
      getWebhookIcon: getWebhookIcon,
      showOptionsNewAttack: showOptionsNewAttack,
      showOptionsNewVuln: showOptionsNewVuln,
      showOptionsNewAsset: showOptionsNewAsset,
      hasCustomSettings: hasCustomSettings,
      hasSelectedWebhook: hasSelectedWebhook,
      isUpdating: isUpdating,
      getSelectedWebhook:
        NotificationOrganizationSettingsService.getSelectedWebhook,
      updateChannel: NotificationOrganizationSettingsService.updateChannel,
      updateChannelReact: updateChannelReact,
      updateActivitySummary:
        NotificationOrganizationSettingsService.updateActivitySummary,
      isMailEnabled: NotificationOrganizationSettingsService.isMailEnabled,
      cleanTrigger: NotificationOrganizationSettingsService.cleanTrigger,
      updateTrigger: NotificationOrganizationSettingsService.updateTrigger,
      updateNotifyOnChange:
        NotificationOrganizationSettingsService.updateNotifyOnChange
    })

    function webhookChanged(webhook) {
      NotificationOrganizationSettingsService.webhookChanged(webhook)
    }

    function getNotificationChannelTooltip() {
      return NotificationOrganizationSettingsService.getSelectedWebhook().valid
        ? tooltipValid
        : tooltipInvalid
    }

    function getWebhookIcon(type) {
      return webhookImgLookup[type] ? webhookImgLookup[type] : ''
    }

    function determineSelectedWebhook(id) {
      var webhooks = $scope.select.webhooks
      var selected
      if (webhooks.length) {
        if (id) {
          selected = findWebhookById(id)
        }
        if (!selected) {
          selected = webhooks[0]
        }
      }
      return selected
    }

    function findWebhookById(id) {
      return $scope.select.webhooks.find(function (webhook) {
        return webhook.value == id
      })
    }

    function loadWebhooks() {
      return WebhookFactory.getWebhooks().then(function (response) {
        response.data.webhooks.forEach(function (wh) {
          $scope.select.webhooks.push({
            value: wh.id,
            webhook_type: wh.webhook_type,
            name: wh.name,
            applications: wh.applications,
            all_applications: wh.all_applications,
            valid: wh.valid
          })
        })
      }, ErrorService.processError)
    }

    function showOptionsNewAttack() {
      return $scope.settings.new_attack.show_options
    }

    function showOptionsNewVuln() {
      return $scope.settings.new_vulnerability.show_options
    }

    function showOptionsNewAsset() {
      return $scope.settings.new_asset.show_options
    }

    function hasCustomSettings() {
      return $scope.settings.custom
    }

    function hasSelectedWebhook() {
      return $scope.settings.selected_webhook
    }

    function isUpdating(keyA, keyB) {
      var val = $scope.settings[keyA]
      if (keyB) {
        val = val[keyB]
      }
      val = val.updating
      return val
    }

    function updateChannelReact(entry, channelKey) {
      // extra step before executing the same logic than in our legacy angular code
      entry[channelKey].enabled = !entry[channelKey].enabled

      // this is the call executed in our legacy angular code
      $scope.updateChannel(
        entry.type.toLowerCase(),
        channelKey,
        $scope.select.vulns_options
      )
    }

    init()
  }
})()
